import { BasicValidators } from './basic.validators';
import { UsernameValidator } from './username';

export const validators: any[] = [BasicValidators, UsernameValidator];

export * from './basic.validators';
export * from './username';
